module.exports = __webpack_public_path__ + "static/media/GCS.c68e2fd2.jfif";